import {
  buildDeleteBookingReservationRequest,
  type DeleteBookingReservationRequest,
  getDeleteBookingReservationInvalidatesTags,
} from './bookingReservationsApi.contract';
import { bookingsApi } from './bookingsApi';

const bookingReservationsApi = bookingsApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteBookingReservation: builder.mutation<void, DeleteBookingReservationRequest>({
      query: (request) => buildDeleteBookingReservationRequest(request),
      invalidatesTags: (result, error, request) => getDeleteBookingReservationInvalidatesTags(request),
    }),
  }),
});

export const { useDeleteBookingReservationMutation } = bookingReservationsApi;
